import { render } from "./SocialIcons.vue?vue&type=template&id=8b225b36&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=ts"
export * from "./SocialIcons.vue?vue&type=script&lang=ts"

import "./SocialIcons.vue?vue&type=style&index=0&id=8b225b36&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8b225b36"

export default script